import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { EventBusService } from 'src/app/admihair/shared/event-bus.service';
import { Subscription } from 'rxjs';
import { ConfirmationService, Message } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { AdministradoraService } from 'src/app/admihair/service/administradora.service';
import { Administradora } from 'src/app/admihair/api/dto/administradora';


@Component({
  selector: 'app-administradora-listar',
  templateUrl: './administradora-listar.component.html',
  styleUrls: ['./administradora-listar.component.scss']
})
export class AdministradoraListarComponent implements OnInit {

  constructor(private administradoraService: AdministradoraService,
    private utilStorageService: UtilStorageService,
    private eventBusService: EventBusService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private erroService: ErroService) { }

  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }];
  messagemVisivel: boolean = false;
  isLoggedIn = false;
  acesso?: any;
  eventBusSub?: Subscription;
  administradoraSelecionada?: Administradora;
  administradoras: Administradora[] = [];
  loading: boolean = false;
  loadingAdminitradoras: boolean = false;

  @ViewChild('filter') filter!: ElementRef;
  ngOnInit(): void {
    this.loadingAdminitradoras = true;
    this.administradoraSelecionada = this.utilStorageService.getAdministradora()
    this.carregarDadosUsuario();
    this.listarAdministradoras();

  }

  private carregarDadosUsuario() {
    this.isLoggedIn = !!this.utilStorageService.getToken();
    if (this.isLoggedIn) {
      this.acesso = this.utilStorageService.getUser();
    }
    this.eventBusSub = this.eventBusService.on('logout', () => {
      this.logout();
    });
  }

  listarAdministradoras() {
    this.administradoraService.listarAdminstradoras().subscribe({
      next: (data: Administradora[]) => {
        this.loadingAdminitradoras = false;
        this.administradoras = data;
      },
      error: (err: any) => {
        this.loadingAdminitradoras = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

 
  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  logout(): void {
    this.utilStorageService.signOut();

    this.isLoggedIn = false;
    this.navigateToFirstChild();
  }

  navigateToFirstChild() {
    this._router.navigate(["/auth/login"], { relativeTo: this._activatedRoute })
  }


  detalhar(id: number) {
    this._router.navigate(["/rfarias/administradora/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  editar(id: number) {
    this._router.navigate(["/rfarias/administradora/editar/" + id], { relativeTo: this._activatedRoute })
  }

  excluir(id: number){
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.administradoraService.excluir(id).subscribe({
          next: () => {
            this.listarAdministradoras();
            this.messages = this.erroService.handleSuccess();
            this.messagemVisivel = true;
            this.rolarTela();
          },
          error: (err: any) => {
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        });
      }
    });
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
